import React, { useEffect, useState } from 'react'
import { translate } from 'reducers/i18n'

import './clientcert.css'
import { PageComponent } from 'components/page';


const ClientCert = props => {
    const {address, authenticators, messageId, tenantId, query, mappings} = props
    const [error, setError] = useState('');
    const [warning, setWarning] = useState('');

    useEffect(() => {
        if(query.status === 'cancelled') {
            setWarning(translate('clientcert_cancelled'));
            setError('');
        } else if (query.status === 'unauthorised') {
            setError(translate('clientcert_unauthorised'));
            setWarning('');
        } else if (query.status === 'error') {
            setError(translate('clientcert_error'));
            setWarning('');
        }
    }, [query.status]);

    const login = () => {
        // Use a nonce (random number) in the URL to make the URL unique. This prevents the browser from using a
        // previous (remembered) value as a choice for the client certificate.
        // Use only 10 possibilities on dev env; this is more convenient because the hosts file does not support
        // wildcard domains.
        let nonce = ~~(Math.random() * 1000)

        let {ca, host: redirectHost} = authenticators[0];
        window.location.href = `https://${ca}-${nonce}.${redirectHost}/login?address=${address}&relay=/edelivery/${tenantId}/messages/${messageId}`;
    }

    return <>
        <div className="loginContentWithImage">
            <PageComponent
              noHeader={true}
              content={mappings["E_DELIVERY_LOGIN_PAGE_CLIENTCERT"]}
              btnFunctions={[() => login()]}
              disabled={false}
            />
            {error && <div className="error">
                <p>{error}</p>
            </div>}
            {warning && <div className="warning">
                <p>{warning}</p>
            </div>}
        </div>
    </>
}

export default ClientCert
